module.exports = __webpack_public_path__ + "img/chunks-8.8264eb35.jpg";